//import routes from "~react-pages"; // This line is required for sitemap
import { Routes, Route } from "react-router";
// import { Component } from "react";
import { UnsavedChangesProvider } from "./components/user/components/UnsavedChangesProvider";
// import ProtectedRoutes from "./ProtectedRoute";
import LoginSignup from "./components/common/user-credentials/LoginSignup";
import MyProfile from "./components/user/My Profile/MyProfile";
import AccountSettings from "./components/user/AccountSettings/AccountSettings";
import MyBids from "./components/user/MyBids/MyBids";
import SavedSearches from "./components/user/SavedSearches/SavedSearches";
import MyPurchaseProfile from "./components/user/MyPurchaseProfile/MyPurchaseProfile";
import Favorites from "./components/user/Favorites/Favorites";
import MyOffers from "./components/user/MyOffers/MyOffers";
import CashForDeed from "./components/user/CFD/CashForDeed";
import UpcomingAuctions from "./components/user/UpcomingAuctions";


// // Error Boundary Component
// class ErrorBoundary extends Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false, errorInfo: null, error: null };
//   }

//   static getDerivedStateFromError(error) {
//     // Update state so the next render will show the fallback UI
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     console.error("Error caught by ErrorBoundary:", error);
//     console.error("Component stack:", errorInfo.componentStack);

//     // Update state with error details
//     this.setState({
//       error: error,
//       errorInfo: errorInfo,
//     });
//   }

//   render() {
//     if (this.state.hasError) {
//       return (
//         <div className="eb-error-container">
//           <h2>Something went wrong.</h2>
//           {this.state.error && (
//             <p className="eb-error-message">{this.state.error.toString()}</p>
//           )}
//           <button
//             onClick={() => window.location.reload()}
//             className="eb-reload-button"
//           >
//             Reload Page
//           </button>
//         </div>
//       );
//     }

//     return this.props.children;
//   }
// }

// // Skeleton loader component
// const SkeletonLoader = () => (
//   <div className="skeleton-container">
//     <div className="hubzu-loader">HUBZU</div>
//   </div>
// );

// Regular imports
import Home from "./pages/home/";
import NotFoundPage from "./pages/not-found";
import FaqPage from "./pages/faq";
import FaqDetailsPage from "./pages/faqDetails";
import UserDashboardPage from "./pages/user/user-dashboard";
import ContactUs from "./pages/ContactUs";
import AboutUsPage from "./pages/about-us";
import SrpPage from "./pages/srp";
import PropertyDetails from "./pages/property-details";
import BidLayout from "./pages/bid";
import InTheNewsScreen from "./pages/InTheNews";
// import CryptoScreen from "./pages/Crypto";
import ForeClosureListings from "./components/pdp/foreClosure";
import OfferLayout from "./pages/offer";
import Sitemap from "./pages/sitemap";
import SellPageResidential from "./pages/sell/residential";
import SellPageCommercial from "./pages/sell/commercial";
// import SellPageBroker from "./pages/sell/broker";
import CashIncentivesScreen from "./pages/CashIncentives";
import CareersScreen from "./pages/Careers";
import EditLayout from "./pages/Editcif";
import CyberMondayScreen from "./pages/CyberMonday";
import BuyersPremiumReductionScreen from "./pages/BuyersPremiumReduction";
import DisclaimerandTradeScreen from "./pages/disclaimerandtrade";
import UnsubscribeScreen from "./pages/Unsubscribe";
import TermsAndCondition from "./pages/terms";
import CommercialTerms from "./pages/commercial-terms";
import EditOffer from "./pages/editOffer";
import ResetPasswordScreen from "./pages/reset-password";
import BidDepositChargeScreen from "./pages/BidDepositCharge";
import CAFCLandingPage from "./pages/CaliforniaFC";
import ShortUrlRedirect from "./components/ShortUrlRedirect";
import CommercialPropertyDetails from "./pages/commercial-property-details";

function Router() {
  return (
    <>
      <Routes>
        {/* Root path configuration */}
        <Route path="/">
          {/* Home page route */}
          <Route index element={<Home />} />
          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<NotFoundPage />} />

          {/* Bid page route */}
          <Route path="/bid" element={<BidLayout />} />
        </Route>
        <Route path="/ci/document/:documentId" element={<EditLayout />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<NotFoundPage />} />
        {/* About Us page route */}
        <Route path="/about/about-us" element={<AboutUsPage />} />
        {/* FAQ page route */}
        <Route path="/support" element={<FaqPage />} />
        <Route path="faqDetails" element={<FaqDetailsPage />} />
        {/* Search Results Page (SRP) route */}
        <Route path="srp" element={<SrpPage />} />
        <Route path="auctions" element={<SrpPage />} />
        <Route path=":stateId/:cityId/auctions" element={<SrpPage />} />
        <Route path=":stateId/auctions" element={<SrpPage />} />
        <Route path=":stateId/:cityId/bank-owned" element={<SrpPage />} />
        <Route path=":stateId/bank-owned" element={<SrpPage />} />
        <Route
          path=":stateId/:cityId/auctions/condos"
          element={<SrpPage />}
        />
        <Route path=":stateId/auctions/condos" element={<SrpPage />} />
        <Route path=":stateId/:cityId/foreclosures" element={<SrpPage />} />
        <Route path=":stateId/foreclosures" element={<SrpPage />} />
        <Route path=":stateId/:cityId/auctions/land" element={<SrpPage />} />
        <Route path=":stateId/auctions/land" element={<SrpPage />} />
        <Route path=":stateId/:cityId/short-sale" element={<SrpPage />} />
        <Route path=":stateId/short-sale" element={<SrpPage />} />
        <Route path=":stateId/:cityId/non-bank-owned" element={<SrpPage />} />
        <Route path=":stateId/non-bank-owned" element={<SrpPage />} />
        <Route path="near-by" element={<SrpPage />} />
        <Route path="near-me" element={<SrpPage />} />
        <Route path="real-estate-auctions-near-me" element={<SrpPage />} />
        <Route path="auctions-near-me" element={<SrpPage />} />
        <Route path="foreclosures-near-me" element={<SrpPage />} />
        <Route path="bank-owned-properties-near-me" element={<SrpPage />} />
        <Route path="bank-owned-near-me" element={<SrpPage />} />
        <Route path="short-sale-properties-near-me" element={<SrpPage />} />
        <Route path="short-sale-near-me" element={<SrpPage />} />
        <Route path="npl-properties-near-me" element={<SrpPage />} />
        <Route path="bank-owned" element={<SrpPage />} />
        {/* <Route path="signatureseller" element={<SrpPage />} /> */}
        {/* <Route path="offmarket" element={<SrpPage />} /> */}
        <Route path="commercial" element={<SrpPage />} />
        <Route path="foreclosures" element={<SrpPage />} />
        <Route path="/foreclosure/:location/auctions" element={<SrpPage />} />
        <Route path="short-sale" element={<SrpPage />} />
        <Route path="traditional-sale" element={<SrpPage />} />
        {/* Property Details page route with dynamic ID parameter */}
        <Route path="bank-owned-home/:id" element={<PropertyDetails />} />
        <Route path="short-sale-home/:id" element={<PropertyDetails />} />
        <Route path="non-bank-owned-home/:id" element={<PropertyDetails />} />
        <Route path="foreclosure-home/:id" element={<PropertyDetails />} />
        <Route path="second-chance-home/:id" element={<PropertyDetails />} />
        <Route path="absolute-auction-home/:id" element={<PropertyDetails />} />
        <Route path="non-performing-loan/:id" element={<PropertyDetails />} />
        <Route path="commercial-building/:id" element={<CommercialPropertyDetails />} />
        <Route path="property/:id" element={<PropertyDetails />} />
        {/* use dashboard */}
        <Route path="user-dashboard" element={<UserDashboardPage />} />
        <Route
          path="my-shopper/myProfile"
          element={
            <UnsavedChangesProvider>
              <MyProfile />
            </UnsavedChangesProvider>
          }
        />
        <Route
          path="my-shopper/accountSettings"
          element={<AccountSettings />}
        />
        <Route path="my-shopper/myBids" element={<MyBids />} />
        <Route path="my-shopper/savedSearches" element={<SavedSearches />} />
        <Route
          path="my-shopper/purchaseProfile"
          element={<MyPurchaseProfile />}
        />
        <Route path="my-shopper/watchProperties" element={<Favorites />} />
        <Route path="my-shopper/myOffers" element={<MyOffers />} />
        <Route path="my-shopper/cash-for-deed" element={<CashForDeed />} />
        <Route path="register-sign-in" element={<LoginSignup />} />
        <Route path="in-the-news" element={<InTheNewsScreen />} />
        <Route
          path="my-shopper/watchComProperties"
          element={<UpcomingAuctions />}
        />
        {/* This page is suspended HUBZ-17586*/}
        {/* <Route path="crypto/forumpay" element={<CryptoScreen />} /> */}
        <Route path="about/careers" element={<CareersScreen />} />
        <Route path="cash-incentive" element={<CashIncentivesScreen />} />
        <Route path="cybermonday" element={<CyberMondayScreen />} />
        <Route path="site-map" element={<Sitemap />} />
        <Route
          path="buyers-premium-reduction"
          element={<BuyersPremiumReductionScreen />}
        />
        <Route path="disclaimer" element={<DisclaimerandTradeScreen />} />
        <Route path="unsubscribe" element={<UnsubscribeScreen />} />
        <Route
          path="foreclosure/eventCalendar"
          element={<ForeClosureListings />}
        />
        {/* <Route element={<ProtectedRoutes />}> */}
        <Route path="offer" element={<OfferLayout />} />
        {/* </Route> */}
        {/* sell */}
        <Route
          path="/sellahomeinanonlineauction"
          element={<SellPageResidential />}
        />

        <Route path="/sell-commercial" element={<SellPageCommercial />} />
        {/* <Route
          path="/sell-a-home-in-an-online-auction/Broker-program"
          element={<SellPageBroker />}
        /> */}
        <Route path="/about/terms" element={<TermsAndCondition />} />
        <Route
          path="/about/commercial-terms"
          element={<CommercialTerms />}
        />
        <Route path="/ciOffer/document/:id" element={<EditOffer />} />
        <Route
          path="/lean-regn/getResetPassword"
          element={<ResetPasswordScreen />}
        />
        <Route path="/bid-deposit-review" element={<BidDepositChargeScreen />} />
        <Route path="/CAForeclosure" element={<CAFCLandingPage />} />
        {/* Short URL redirect - resolves /l/:code via API */}
        <Route path="/l/:code" element={<ShortUrlRedirect />} />
      </Routes>
    </>
  );
}

// Export the App component as the default export
export default Router;
